import { GET_ALL_ACTIONS } from "../actions/types";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case `${GET_ALL_ACTIONS}_PENDING`:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case `${GET_ALL_ACTIONS}_FULFILLED`:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
      };
    case `${GET_ALL_ACTIONS}_REJECTED`:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
